import {RoomPlanner} from 'components/customer/RoomPlanner/store/roomPlannerSlice';
import {HistoryStack} from 'components/customer/RoomPlanner/types';

const MAX_HISTORY_STACK_SIZE = 10;

// When adding to an empty history list, insert a "Revert" snapshot as the first item
const createRevertSnapshot = (historyItem: HistoryStack): HistoryStack => ({
    ...historyItem,
    title: `*Revert:* ${historyItem.title}`,
    isActive: false,
    data: {...historyItem.data},
});

// Helper function to add item to history stack
export const addToHistoryStackHelper = (
    state: RoomPlanner,
    historyItem: HistoryStack,
    options?: {
        clearAfterActive?: boolean;
        skipMaxSizeCheck?: boolean;
    }
) => {
    const {clearAfterActive = false} = options || {};

    // When adding the first item to an empty list, duplicate it as a "Revert" entry at index 0
    if (state.historyStack.length === 0) {
        state.historyStack.unshift(createRevertSnapshot(historyItem));
    }

    // If there's an active item and we need to clear redo history, remove items after it
    if (clearAfterActive) {
        const activeIndex = state.historyStack.findIndex(
            (item) => item.isActive
        );
        if (activeIndex !== -1) {
            state.historyStack.splice(activeIndex + 1);
        }
    }

    // Set all previous items to inactive
    state.historyStack.forEach((item, index) => {
        if (index === 0) {
            item.recentlyUndone = false;
            item.recentlyRedone = true;
        }
        item.isActive = false;
    });

    // Add the new item
    state.historyStack.push(historyItem);

    // Always enforce max stack size limit, regardless of skipMaxSizeCheck
    // Remove oldest items if we exceed the limit
    while (state.historyStack.length > MAX_HISTORY_STACK_SIZE) {
        state.historyStack.shift();
    }
};
